import _sfc_main from "./Notification.vue2.js";
/* empty css                  */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Notification = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a5d23a78"]]);
export {
  Notification as default
};
//# sourceMappingURL=Notification.vue.js.map
